import React, { useEffect, useState } from "react";
import DashboardCalendar from "../../Widgets/DashboardCalender/DashboardCalender";
import "./HospitalDashboard.css";
import ClinicDashboardDetails from "./clinicDashboardDetails";
import strings from "../../Utils/strings";
import { useNavigate } from "react-router";
import moment from "moment";
import constants from "../../Utils/constants";
import { t } from "../../Utils/translate";
import clinicService from "../../Services/clinicService";
import { hospitalAppointment } from "../../Services/clinicService";
import authService from "../../Services/authService";
import { useSelector } from "react-redux";

const HospitalDashboard = () => {
  const nav = useNavigate();
  const isRefresh = useSelector((state) => state.refreshNoti.refreshNoti);
  const [tableHeaderChange, setTableHeaderChange] = useState("");
  const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [dateChange, setDateChange] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [isCalenderChanged, setIsCalenderChanged] = useState(false);
  const [appointmentRequestCount, setAppointmentRequestCount] = useState(0);
  const [selectedMonthDate, setSelectedMonthDate] = useState("");
  const [isMonthChange, setIsMonthChange] = useState(false);
  const [requestedAppointmentId, setRequestedAppointmentId] = useState("");
  const [requestAppointmentsDate, setRequestAppointmentsDate] = useState("");
  const [requestedAppointmentDoctorId, setRequestedAppointmentDoctorId] = useState("");
  const [appointmentPage, setAppointmentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false); // Optional loading state
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    const currentDate = moment().format(constants.dateFormat.standardDate);
    setSelectedDate(currentDate);
  }, []);

  useEffect(() => {
    fetchAppointments();
  }, [isCalenderChanged, dateChange]);

  const dashboardTitleChange = (data) => {
    setTableHeaderChange(data);
  };

  const handleDateChange = (date) => {
    setDateChange(date);
  };

  const handleOnChangeCalender = (changeCalender) => {
    setIsCalenderChanged(changeCalender);
    setIsMonthChange(false);
  };

  const handleOnMonthChange = (monthChange) => {
    setSelectedMonthDate(monthChange);
    setIsMonthChange(true);
  };

  const handleAppointmentPage = (count) => {
    setAppointmentPage(count);
  };

  const fetchAppointments = async (load) => {
    const docBody = {
      date: date || new Date().toISOString().split("T")[0],
      statuses: ["WAITING_FOR_CLINIC_CONFIRMATION"],
    };

    try {
      if(load !== "load"){
        setIsLoading(true);
      };
      let apiResponse;

      if (authService.getIsDoctorLogin() === "true") {
        apiResponse = await clinicService.docGetAllAppointment(docBody);
        setAppointments(apiResponse?.data?.appointments || []);
        setAppointmentRequestCount(apiResponse.data.appointments.length || 0);
      } else if (authService.getIsDoctorLogin() === "false") {
        const requestBody = {
          date: date || new Date().toISOString().split("T")[0],
          statuses: ["WAITING_FOR_CLINIC_CONFIRMATION"],
        };

        const jwtToken = localStorage.getItem("FV_sessionToken");

        apiResponse = await clinicService.hospitalAppointmentDashboard(requestBody, jwtToken);
        if (apiResponse) {
          setAppointments(apiResponse?.appointments || []);
          setAppointmentRequestCount(apiResponse.appointments.length || 0);
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching appointments by doctor:", error.message);
    }
  };
 
      useEffect(() => {
      fetchAppointments("load")
    }, [isRefresh]);

  return (
    <div className="hospital-container">
      <div className="p-3 hospital-inner-div">
        <h6 className="screen-name">{t("dashboard")}</h6>
        {appointmentRequestCount > 0 && authService.getIsDoctorLogin() === "false" ? (
          <div className="screen-name container-sm dashboard">
            <div className="flex items-center mt-4">
              <div className="grow flex">
                <i className="ri-alarm-warning-line me-2 icon"></i>
                <span className="pending-appointment">
                  {t("pendingAppointment")} ({appointmentRequestCount})
                </span>
              </div>
              <div className="p-2">
                {appointmentRequestCount > 0 ? (
                  <button
                    type="button"
                    className="btn btn-danger action mt-2 text-nowrap"
                    onClick={() => {
                      nav(strings.navigation.appointmentRequest);
                    }}
                  >
                    {t("takeAction")}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
 
        <div className="flex mt-3">
          <div className={appointmentRequestCount > 0 ? "container-lg container-sm container-md dashboard-details" : "container dashboard"}>
            <h6 className="mt-3 schedule">{t("schedule")}</h6>
            <div className="appointment-parent px-1 flex">
              <div className="dashboard-parent-col appointment-parent-col-1 mt-1 pb-2">
                <DashboardCalendar
                  titleChange={tableHeaderChange}
                  func={(value) => {
                    handleDateChange(value);
                  }}
                  monthChange={(value) => {
                    handleOnMonthChange(value);
                  }}
                  onCalenderChange={(value) => {
                    handleOnChangeCalender(value);
                  }}
                  isMonthChange={(value) => {
                    handleOnChangeCalender(value);
                  }}
                  pendingAppointmentCount={appointmentRequestCount}
                />
              </div>
              <div className="dashboard-parent-col-2 dashboard-parent-col-2">
                <ClinicDashboardDetails
                  dashboardTitleChange={dashboardTitleChange}
                  dateChange={dateChange}
                  monthChange={selectedMonthDate}
                  isCalenderChanged={isCalenderChanged}
                  isMonthChange={(value) => {
                    handleOnChangeCalender(value);
                  }}
                  appointmentPage={handleAppointmentPage}
                  pendingAppointmentCount={appointmentRequestCount}
                />
              </div>
            </div>
            <div className="extra-gap" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HospitalDashboard;
